export const COUNT_BYS = ['keyResults', 'objectives'] as const;

export const OVERVIEW_VIEWS = ['list', 'card', 'detail', 'relationships'] as const;

export const TRACKING_STATUSES = ['offTrack', 'atRisk', 'onTrack', 'achieved'] as const;

export const AVAILABLE_OVERVIEW_VIEWS = ['list'] as const;
